import {
    SET_TRUST_CENTER_LOADING,
    REMOVE_TRUST_CENTER_LOADING
} from  '../types'

const initialState = {
    loading: false,
}


export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case SET_TRUST_CENTER_LOADING:
            return {
                ...state,
                loading: true,
            };
        case REMOVE_TRUST_CENTER_LOADING:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}
